import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { Pill } from '@feathr/components';
import { EPlatforms, platformIconMap } from '@feathr/extender/styles/platform';

export interface IProps {
  readonly platform: keyof typeof EPlatforms;
}

function PlatformChip({ platform }: IProps): JSX.Element {
  const platformIcon = platformIconMap[platform];

  return (
    <Pill prefix={platformIcon ? <FontAwesomeIcon icon={platformIcon} /> : undefined}>
      {EPlatforms[platform] || 'Other'}
    </Pill>
  );
}

export default observer(PlatformChip);
